import elementIsVisible from '../../core/INF-elementIsVisible';
import { resizeVideo } from './resizeVideos';
import initControls from './initControls';

// Make an index of videos for potential use later in theme editor
const native_players = {};

const nativePlayerInit = (container, start = 0) => {
  const containerElement = container;
  const playerElement = container.querySelector('[data-video-player]');
  const playerId = playerElement.id;

  resizeVideo(containerElement);

  const canPlayThrough = () => {
    native_players[playerId] = playerElement;

    setTimeout(() => {
      if (elementIsVisible(containerElement)) {
        native_players[playerId].currentTime = start;
        native_players[playerId].play();
      }

      initControls(containerElement, native_players[playerId], 'native');

      if (start > 0) {
        containerElement.classList.add('BackgroundVideo--immediate');
      }

      containerElement.classList.add('BackgroundVideo--init');
    }, 50);
  };

  playerElement.addEventListener('canplaythrough', () => {
    if (native_players[playerId]) {
      return;
    }

    canPlayThrough();
  });

  if (playerElement.readyState > 3 && !native_players[playerId]) {
    canPlayThrough();
  } else if (playerElement.readyState < 4 && !native_players[playerId]) {
    playerElement.load();
  }
};

export { native_players, nativePlayerInit };
